import React, { useState } from 'react';
import { Eye, EyeOff, Plus, Minus, Moon, Sun } from 'lucide-react';
import { useTheme } from './ThemeContext';
export function ManagementScreen() {
  const [botEnabled, setBotEnabled] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [evaluatePhotos, setEvaluatePhotos] = useState(false);
  const {
    theme,
    toggleTheme
  } = useTheme();
  const [questions, setQuestions] = useState<string[]>([]);
  const addQuestion = () => {
    setQuestions([...questions, '']);
  };
  const removeQuestion = (index: number) => {
    setQuestions(questions.filter((_, i) => i !== index));
  };
  return <div className="min-h-screen bg-svt-bg" data-id="element-133">
      {/* Header */}
      <div className="sticky top-0 z-40 bg-svt-bg/80 backdrop-blur-xl border-b border-svt-border transition-colors duration-300" data-id="element-134">
        <div className="flex items-center justify-between px-6 py-4" data-id="element-135">
          <div className="flex items-center gap-3" data-id="element-136">
            <img src="https://cdn.magicpatterns.com/uploads/x3zgz2YSJzc57ZhT1dBqrP/logo.png" alt="SVT Dating" className="h-8 w-auto" data-id="element-137" />
            <span className="font-serif text-xl font-bold tracking-wide text-svt-text" data-id="element-138">
              Управление
            </span>
          </div>
          <div className="flex items-center bg-svt-overlay rounded-full p-1 border border-svt-border" data-id="element-139">
            <button onClick={theme === 'light' ? toggleTheme : undefined} className={`p-1.5 rounded-full transition-all duration-300 ${theme === 'dark' ? 'bg-gradient-primary text-white shadow-md' : 'text-svt-text-muted hover:text-svt-text'}`} data-id="element-140">
              <Moon size={14} data-id="element-141" />
            </button>
            <button onClick={theme === 'dark' ? toggleTheme : undefined} className={`p-1.5 rounded-full transition-all duration-300 ${theme === 'light' ? 'bg-gradient-primary text-white shadow-md' : 'text-svt-text-muted hover:text-svt-text'}`} data-id="element-142">
              <Sun size={14} data-id="element-143" />
            </button>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="px-6 py-6 space-y-6" data-id="element-144">
        {/* СТАТУС */}
        <div data-id="element-145">
          <label className="block text-xs font-bold tracking-widest uppercase text-svt-text-muted mb-3" data-id="element-146">
            Статус
          </label>
          <button onClick={() => setBotEnabled(!botEnabled)} className="w-full flex items-center justify-between p-4 rounded-2xl bg-svt-surface border border-svt-border hover:bg-svt-surface-hover transition-colors" data-id="element-147">
            <div className="flex items-center gap-3" data-id="element-148">
              <div className={`w-3 h-3 rounded-full ${botEnabled ? 'bg-green-500' : 'bg-red-500'}`} data-id="element-149"></div>
              <span className={`font-medium ${botEnabled ? 'text-green-400' : 'text-red-400'}`} data-id="element-150">
                {botEnabled ? 'Включен' : 'Выключен'}
              </span>
            </div>
            <div className={`w-12 h-6 rounded-full transition-colors relative ${botEnabled ? 'bg-green-500' : 'bg-svt-border'}`} data-id="element-151">
              <div className={`absolute top-0.5 w-5 h-5 rounded-full bg-white transition-transform ${botEnabled ? 'translate-x-6' : 'translate-x-0.5'}`} data-id="element-152"></div>
            </div>
          </button>
        </div>

        {/* ЛОГИН */}
        <div data-id="element-153">
          <label className="block text-xs font-bold tracking-widest uppercase text-svt-text-muted mb-3" data-id="element-154">
            Логин
          </label>
          <input type="email" placeholder="Введите логин" className="w-full px-4 py-3 rounded-2xl bg-svt-surface border border-svt-border text-svt-text placeholder:text-svt-text-faint focus:outline-none focus:border-svt-pink/50 transition-colors" data-id="element-155" />
        </div>

        {/* ПАРОЛЬ */}
        <div data-id="element-156">
          <label className="block text-xs font-bold tracking-widest uppercase text-svt-text-muted mb-3" data-id="element-157">
            Пароль
          </label>
          <div className="relative" data-id="element-158">
            <input type={showPassword ? 'text' : 'password'} placeholder="Введите пароль" className="w-full px-4 py-3 pr-12 rounded-2xl bg-svt-surface border border-svt-border text-svt-text placeholder:text-svt-text-faint focus:outline-none focus:border-svt-pink/50 transition-colors" data-id="element-159" />
            <button onClick={() => setShowPassword(!showPassword)} className="absolute right-4 top-1/2 -translate-y-1/2 text-svt-text-muted hover:text-svt-text transition-colors" data-id="element-160">
              {showPassword ? <EyeOff size={18} data-id="element-161" /> : <Eye size={18} data-id="element-162" />}
            </button>
          </div>
        </div>

        {/* ГОРОД */}
        <div data-id="element-163">
          <label className="block text-xs font-bold tracking-widest uppercase text-svt-text-muted mb-3" data-id="element-164">
            Город
          </label>
          <input type="text" placeholder="Введите город" className="w-full px-4 py-3 rounded-2xl bg-svt-surface border border-svt-border text-svt-text placeholder:text-svt-text-faint focus:outline-none focus:border-svt-pink/50 transition-colors" data-id="element-165" />
        </div>

        {/* ОЦЕНИВАТЬ ФОТО ПРОФИЛЯ */}
        <div data-id="element-166">
          <button onClick={() => setEvaluatePhotos(!evaluatePhotos)} className="flex items-center gap-3 group" data-id="element-167">
            <div className={`w-6 h-6 rounded-lg border-2 flex items-center justify-center transition-all ${evaluatePhotos ? 'bg-green-500 border-green-500' : 'border-svt-border group-hover:border-svt-border-hover'}`} data-id="element-168">
              {evaluatePhotos && <svg className="w-4 h-4 text-white" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor" data-id="element-169">
                  <path d="M5 13l4 4L19 7" data-id="element-170"></path>
                </svg>}
            </div>
            <span className="text-sm font-medium text-svt-text-muted uppercase tracking-wider" data-id="element-171">
              Оценивать фото профиля
            </span>
          </button>
        </div>

        {/* ТРЕБОВАНИЯ К КАНДИДАТУ */}
        <div data-id="element-172">
          <label className="block text-xs font-bold tracking-widest uppercase text-svt-text-muted mb-3" data-id="element-173">
            Требования к кандидату
          </label>
          <textarea rows={12} placeholder="Опишите требования к кандидату..." className="w-full px-4 py-3 rounded-2xl bg-svt-surface border border-svt-border text-svt-text text-sm leading-relaxed placeholder:text-svt-text-faint focus:outline-none focus:border-svt-pink/50 transition-colors resize-none" data-id="element-174" />
        </div>

        {/* ВОПРОСЫ КАНДИДАТУ */}
        <div data-id="element-175">
          <div className="flex items-center justify-between mb-3" data-id="element-176">
            <label className="text-xs font-bold tracking-widest uppercase text-svt-text-muted" data-id="element-177">
              Вопросы кандидату
            </label>
            <button onClick={addQuestion} className="w-8 h-8 rounded-lg bg-svt-surface border border-svt-border hover:bg-svt-surface-hover transition-colors flex items-center justify-center" data-id="element-178">
              <Plus size={16} className="text-svt-text-muted" data-id="element-179" />
            </button>
          </div>
          <div className="space-y-3" data-id="element-180">
            {questions.map((question, index) => <div key={index} className="flex gap-3" data-id="element-181">
                <div className="flex-1 p-4 rounded-2xl bg-svt-surface border border-svt-border text-sm text-svt-text leading-relaxed" data-id="element-182">
                  {question}
                </div>
                <button onClick={() => removeQuestion(index)} className="w-10 h-10 flex-shrink-0 rounded-lg bg-svt-surface border border-svt-border hover:bg-svt-surface-hover transition-colors flex items-center justify-center" data-id="element-183">
                  <Minus size={16} className="text-svt-text-muted" data-id="element-184" />
                </button>
              </div>)}
          </div>
        </div>

        {/* Запустить Button */}
        <button className="w-full py-4 rounded-full bg-green-500 hover:bg-green-600 text-white font-bold text-lg transition-all shadow-[0_0_20px_rgba(34,197,94,0.3)] hover:shadow-[0_0_30px_rgba(34,197,94,0.5)]" data-id="element-185">
          Запустить
        </button>

        {/* ЛОГИ */}
        <div data-id="element-186">
          <label className="block text-xs font-bold tracking-widest uppercase text-svt-text-muted mb-3" data-id="element-187">
            Логи
          </label>
          <div className="p-4 rounded-2xl bg-svt-surface border border-svt-border font-mono text-sm space-y-2" data-id="element-188">
            <div className="flex gap-3" data-id="element-189">
              <span className="text-svt-pink flex-shrink-0" data-id="element-190">16:23:14</span>
              <span className="text-svt-text-secondary" data-id="element-191">
                Состояние бота изменено! Изменения применятся в течение 15
                секунд...
              </span>
            </div>
            <div className="flex gap-3" data-id="element-192">
              <span className="text-svt-pink flex-shrink-0" data-id="element-193">16:23:17</span>
              <span className="text-svt-text-secondary" data-id="element-194">Запуск бота...</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}